export default function() {
    return document.documentElement.clientWidth <= 800;
}
